import { render, staticRenderFns } from "./MagnetBlock.vue?vue&type=template&id=2524029a"
import script from "./MagnetBlock.vue?vue&type=script&lang=js"
export * from "./MagnetBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports